import React from 'react';
import Producto from '../containers/producto'


const Cuerpo = (props) => (
	<section>
		<Producto productoId={props.match.params.id}  history={props.history}/>
	</section>
);

export default Cuerpo;



// WEBPACK FOOTER //
// ./src/components/cuerpo.js